var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5846 26.0444C34.5839 28.3807 33.7853 30.6466 32.3211 32.4671C30.857 34.2876 28.815 35.5535 26.5333 36.0553L25.4433 32.7855C26.4414 32.6211 27.3906 32.2374 28.2225 31.6619C29.0543 31.0865 29.7482 30.3336 30.254 29.4577H26.043C25.1368 29.4577 24.2678 29.0977 23.627 28.457C22.9863 27.8162 22.6263 26.9472 22.6263 26.041V19.2077C22.6263 18.3015 22.9863 17.4325 23.627 16.7917C24.2678 16.151 25.1368 15.791 26.043 15.791H31.0621C30.6452 12.4886 29.0375 9.45186 26.5408 7.2505C24.0441 5.04915 20.8299 3.83452 17.5013 3.83452C14.1727 3.83452 10.9585 5.04915 8.46178 7.2505C5.96506 9.45186 4.35744 12.4886 3.94055 15.791H8.95964C9.86579 15.791 10.7348 16.151 11.3756 16.7917C12.0163 17.4325 12.3763 18.3015 12.3763 19.2077V26.041C12.3763 26.9472 12.0163 27.8162 11.3756 28.457C10.7348 29.0977 9.86579 29.4577 8.95964 29.4577H3.83464C2.92848 29.4577 2.05944 29.0977 1.41869 28.457C0.777938 27.8162 0.417969 26.9472 0.417969 26.041V17.4993C0.417969 8.06422 8.06618 0.416016 17.5013 0.416016C26.9364 0.416016 34.5846 8.06422 34.5846 17.4993V26.0444ZM31.168 26.041V19.2077H26.043V26.041H31.168ZM3.83464 19.2077V26.041H8.95964V19.2077H3.83464Z",
    fill: "#E541ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.761a2359d04dc28b53c57817f6a78368.svg";
export { ForwardRef as ReactComponent };